module.exports = __webpack_public_path__ + "img/photo3.6ea749be.png";